
const handleClick = ({ closeModal, props, event}, { onClick, redirect, history, dispatch, handleNext  }) => {
  if (redirect) {
    closeModal(props);
    history.push(redirect);
  }
  if (onClick === true) {
    handleNext && handleNext();
  } else {
    onClick && onClick(event);
  }
  dispatch({
    type: "CLEAR_ERROR",
  });
  closeModal(props);
};

export default handleClick;
